<div class="control">
  <label>År</label>
  <p-select
    [(ngModel)]="plService.aar"
    [options]="aarOptions()"
    optionLabel="aar"
    optionValue="aar"
    placeholder="Vælg" />
</div>
<div class="control">
  <label>Produkt type</label>
  <p-select
    [(ngModel)]="plService.produktType"
    [options]="produktTyperGrouped()"
    [group]="true"
    scrollHeight="400px"
    optionLabel="navn"
    optionGroupLabel="navn"
    placeholder="Vælg"
    appendTo="body" />
</div>
@if (
  plService.produktType()?.type === 'lts' ||
  plService.produktType()?.type === 'standalone'
) {
  <div class="control">
    <label>Betalingsfrekvens</label>
    <p-select
      [(ngModel)]="plService.opkraevningsfrekvens"
      [options]="opkraevningsfrekvensOptions()"
      placeholder="Vælg"
      appendTo="body" />
  </div>
  <div class="control">
    <label>Skattekode</label>
    <p-select
      [(ngModel)]="plService.skattekode"
      [options]="skattekodeOptions()"
      placeholder="Vælg"
      appendTo="body" />
  </div>
  <div class="control">
    <label>Prisgruppe</label>
    <p-select
      [(ngModel)]="plService.prisgruppe"
      [options]="prisgruppeOptions()"
      placeholder="Vælg"
      appendTo="body" />
  </div>
  @if (praemiefritagelseVisible()) {
    <div class="control">
      <label>Præmiefritagelse</label>
      <p-checkbox [(ngModel)]="plService.praemiefritagelse" [binary]="true" />
    </div>
  }
  @if (plService.foedselsdatoRequired()) {
    <div class="control">
      <label>Fødselsdato</label>
      <p-date-picker
        [(ngModel)]="plService.foedselsdato"
        [showIcon]="true"
        dateFormat="dd-mm-yy"
        [defaultDate]="defaultFoedselsdato" />
    </div>
  }
  @if (plService.bidragRequired()) {
    <div class="control">
      <label>Samlet månedligt bidrag</label>
      <p-input-number
        [(ngModel)]="plService.bidrag"
        locale="da"
        [maxFractionDigits]="2"
        suffix=" kr."
        mode="decimal" />
    </div>
  }
  @if (plService.valgtProduktPris.value()) {
    <div class="control">
      <label>Dækningsspænd</label>
      <div>
        min. {{ plService.valgtProduktPris.value()?.minDaekning | number }} kr.
        - max.
        {{ plService.valgtProduktPris.value()?.maxDaekning | number }} kr.
      </div>
    </div>
    <div class="control">
      <label>Dækningsstørrelse</label>
      <p-input-number
        [(ngModel)]="plService.daekningsstoerrelse"
        locale="da"
        [maxFractionDigits]="2"
        suffix=" kr."
        mode="decimal"
        [min]="plService.valgtProduktPris.value()?.minDaekning!"
        [max]="plService.valgtProduktPris.value()?.maxDaekning!" />
    </div>
  }
}
<div class="flex gap-2">
  @if (
    plService.produktType()?.type === 'standalone' ||
    plService.produktType()?.type === 'lts'
  ) {
    <p-button
      label="Beregn"
      (click)="onClickCalc()"
      icon="pi pi-calculator"
      type="submit"
      [disabled]="!plService.paramsValid()" />
  }
  <p-button
    label="Nulstil"
    (click)="onClickReset()"
    icon="pi pi-times"
    severity="secondary"
    outlined />
</div>
